import { STORAGE_KEY, STORYGRAPH_PILL_STYLE, type TransferData } from '../../constants'
import { maybeDownloadCover } from '../../utils/download'
import { getUserOptions } from '../settings'
import { parsePubuPage } from './parser'

const PUBU_BUTTON_ID = 'pubu-port-to-sg-btn'

function openStoryGraphSearch (data: TransferData): void {
  const query = data.isbn || data.title
  const url = `https://app.thestorygraph.com/browse?search_term=${encodeURIComponent(query)}`
  if (typeof GM_openInTab === 'function') {
    GM_openInTab(url, { active: true })
  } else {
    window.open(url, '_blank')
  }
}

function isPubuBookPage (): boolean {
  return /^\/ebook\/\d+/.test(window.location.pathname)
}

function getButtonHost (): HTMLElement | null {
  return document.querySelector<HTMLElement>('.info-name h1, .info-block h1, h1.h4, section.info-block h1')
}

export function injectPubuPortButton (): void {
  if (!isPubuBookPage()) return

  const host = getButtonHost()
  if (!host) return

  const existing = document.getElementById(PUBU_BUTTON_ID) as HTMLAnchorElement | null
  if (existing) {
    if (existing.previousElementSibling !== host) host.insertAdjacentElement('afterend', existing)
    return
  }

  const btn = document.createElement('a')
  btn.id = PUBU_BUTTON_ID
  btn.href = '#'
  btn.textContent = 'Port to StoryGraph'
  btn.style.cssText = `${STORYGRAPH_PILL_STYLE} margin:6px 0 0;`
  host.insertAdjacentElement('afterend', btn)

  btn.addEventListener('click', (event) => {
    event.preventDefault()
    const data = parsePubuPage()
    const options = getUserOptions()

    console.log('[StoryGraphEnhancer] Pubu porting:', JSON.stringify(data, null, 2))

    if (options.downloadPubuCover) {
      maybeDownloadCover(data.title, data.coverUrl)
    }

    GM_setValue(STORAGE_KEY, JSON.stringify(data))
    openStoryGraphSearch(data)
  })
}
